import './NavBar.css'

import { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'

import circleIconUser from './imgs/account_circle_white_24dp-biggg.svg'
import icon from './imgs/Logo_f.svg'
import logoutIcon from './imgs/logout_icon.svg'
import ContactUs from './PageComponents/ClientSide/ContactUs'
import { setLoggedUserAction } from './store/userSlice'

export default function NavBar() {
  const dispatch = useDispatch()
  const history = useHistory()
  const hamburgerRef = useRef(null)
  const navMenuRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)
  const { loggedUser } = useSelector(state => state.user)
  const [isShowContactUs, setisShowContactUs] = useState(false)

  useEffect(() => {
    setIsMobile(window.matchMedia('only screen and (max-width: 760px)').matches)
  }, [])
  const logOutHandler = async () => {
    try {
      localStorage.removeItem('cognito-tokens')
      dispatch(
        setLoggedUserAction({
          UserAttributes: null,
          Username: null,
          groups: [],
          permissions: {
            Admin: false,
            Agent: false,
            OfficeManager: false,
            SeniorAgent: false,
            Worker: false,
          },
        })
      )
      history.push('/')
    } catch (error) {
      throw error
    }
  }

  function mobileMenu() {
    if (!isMobile) return
    hamburgerRef.current.classList.toggle('active')
    navMenuRef.current.classList.toggle('active')
  }

  return (
    <header className='header' data-bs>
      <nav className='navbar1'>
        <a href='http://www.shiptanbul.com/' className='nav-link1'>
          <img alt='icon' width='200px' src={icon} />
        </a>
        <ul className='nav-menu' ref={navMenuRef}>
          <li className='nav-item'>
            <a href='https://www.shiptanbul.com/about' className='nav-link1'>
              נעים להכיר
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://www.shiptanbul.com/start-here' className='nav-link1'>
              איך זה עובד
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://shiptanbul.com/shops/usa' className='nav-link1'>
              חנויות מומלצות
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://www.shiptanbul.com/knowledge-center' className='nav-link1'>
              מרכז הידע והתמיכה
            </a>
          </li>
          <li className='nav-item'>
            <a href='https://shiptanbul.com/calculator' className='nav-link1'>
              מחשבונים
            </a>
          </li>
          <li className='nav-item'>
            <a className='nav-link1' onClick={() => setisShowContactUs(true)}>
              צור קשר
            </a>
          </li>

          {loggedUser.Username ? (
            <li className='nav-item nav-user'>
              <Link
                to='/personal-info'
                className='nav-link1'
                onClick={() => {
                  mobileMenu()
                }}
              >
                <div>
                  {loggedUser.UserAttributes.name}
                  <img src={circleIconUser} />
                </div>
              </Link>
            </li>
          ) : (
            <li className='nav-item' style={{ marginLeft: '1rem' }}>
              <Link
                to='/'
                className='nav-link1'
                onClick={() => {
                  mobileMenu()
                }}
              >
                <Button variant='primary' style={{ maxWidth: '110px', fontSize: '15px' }}>
                  התחברות
                </Button>
              </Link>
            </li>
          )}

          {loggedUser.Username && (
            <img
              src={logoutIcon}
              className='logout-btn'
              onClick={() => {
                logOutHandler()
                mobileMenu()
              }}
            />
          )}
        </ul>
        <div
          ref={hamburgerRef}
          className='hamburger'
          onClick={() => {
            mobileMenu()
          }}
        >
          <span className='bar'></span>
          <span className='bar'></span>
          <span className='bar'></span>
        </div>
      </nav>
      <ContactUs show={isShowContactUs} setShow={setisShowContactUs} />
    </header>
  )
}
